/*
 * Creates a jQuery plugin ($.fn.ajaxify) to attach
 * to internal anchor tags. Over-rides default click
 * behaviour to get the href location response via 
 * a AJAX GET request to limit unneccessary HTTP requests 
 * like scripts, css, fonts and allow animations between pages
 * 
 * @author BarrelNY
 * @link https://github.com/browserstate/ajaxify
 * Based off Ajaxify v1.0.1 (30 September, 2012)
 *
 */

(function(window,undefined){
	
	// Prepare our Variables
	var
		History = window.History,
		$ = window.jQuery,
		document = window.document;

	// Check to see if History.js is enabled for our Browser
	if ( !History.enabled ) {
		return false;
	}

	// Wait for Document
	$(function(){
		// Prepare Variables
		var
			/* Application Specific Variables */
			contentSelector = '#content,article:first,.article:first,.post:first, #ajax-content-container',
			$content = $(contentSelector).filter(':first'),
			contentNode = $content.get(0),
			$menu = $('#menu,#nav,nav:first,.nav:first').filter(':first'),
			activeClass = 'active selected current youarehere',
			activeSelector = '.active,.selected,.current,.youarehere',
			menuChildrenSelector = '> li,> ul > li',
			completedEventName = 'statechangecomplete',
			/* Application Generic Variables */
			$window = $(window),
			$body = $(document.body),
			rootUrl = History.getRootUrl(),
			scrollOptions = {
				duration: 800,
				easing:'swing'
			};
		
		// Ensure Content
		if ( $content.length === 0 ) {
			$content = $body;
		}
		
		// Internal Helper
		$.expr[':'].internal = function(obj, index, meta, stack){
			// Prepare
			var
				$this = $(obj),
				url = $this.attr('href')||'',
				isInternalLink;
			
			// Check link
			isInternalLink = url.substring(0,rootUrl.length) === rootUrl || url.indexOf(':') === -1;
			
			// Ignore or Keep
			return isInternalLink;
		};
		
		// HTML Helper
		var documentHtml = function(html){
			// Prepare
			var result = String(html)
				.replace(/<\!DOCTYPE[^>]*>/i, '')
				.replace(/<(body).*class="(.[^"]*)"([\s\>])/gi,'<div class="document-$1" data-class="$2"$3')
				.replace(/<(html|head|title|meta|script)([\s\>])/gi,'<div class="document-$1"$2')
				.replace(/<\/(html|head|body|title|meta|script)\>/gi,'</div>')
			;
			
			// Return
			return $.trim(result);
		};
		
		// Ajaxify Helper
		$.fn.ajaxify = function(){
			// Prepare
			var 
				$this  = $(this);
			
			//Associate handlers via delegation
			$this.on('click','a:internal:not(.no-ajaxy)',AjaxifyHander);
			
			function AjaxifyHander(event){
				var
					$this = $(this),
					url = $this.attr('href'),
					title = $this.attr('title')||null;
				
				// Continue as normal for cmd clicks etc
				if ( event.which == 2 || event.metaKey ) { return true; }
				
				// Ajaxify this link
				History.pushState(null,title,url);
				event.preventDefault();
				return false;
			}
			
			// Chain
			return $this;
		};
		
		// Ajaxify our Internal Links
		$body.ajaxify();
		
		// Hook into State Changes
		$window.bind('statechange',function(){
			// Prepare Variables
			var
				State = History.getState(),
				url = State.url,
				relativeUrl = url.replace(rootUrl,'');

			// Set Loading
			$body.addClass('loading');

			var FADEIN_REQUESTS = 0;
			
			// Start Fade Out
			// Animating to opacity to 0 still keeps the element's height intact
			// Which prevents that annoying pop bang issue when loading in new content
			$('video').hide();
			
			if ( !MUR.isSmall() ){
			
				new TimelineMax(
					{
						onComplete:function(){
							FadeIn();
						}
					}
				)
				.set('video',{display:'none'})
				.set($content,{overflow:'hidden',height:$(window).height()})
				.to($content,1,{opacity:0,scale:0.97})
			
			}
			
			var PERSISTANT = {};
			
			// Ajax Request the Traditional Page
			$.ajax({
				url: url,
				method:"GET",
				success: function(data, textStatus, jqXHR){
					//Refresh cache
					PERSISTANT = {};
					
					// Prepare
					PERSISTANT.$data = $(documentHtml(data));
					PERSISTANT.$dataBody = PERSISTANT.$data.find('.document-body:first');
					PERSISTANT.$dataContent = PERSISTANT.$dataBody.find(contentSelector).filter(':first');
					PERSISTANT.bodyClasses = PERSISTANT.$dataBody.attr('data-class');
					
					var $menuChildren;
					
					// Fetch the scripts
					PERSISTANT.$scripts = PERSISTANT.$dataContent.find('.document-script');
					if ( PERSISTANT.$scripts.length ) {
						PERSISTANT.$scripts.detach();
					}

					// Fetch the content
					PERSISTANT.contentHtml = PERSISTANT.$dataContent.html()||PERSISTANT.$data.html();
					if ( !PERSISTANT.contentHtml ) {
						document.location.href = url;
						return false;
					}
					
					// Update the menu
					$menuChildren = $menu.find(menuChildrenSelector);
					$menuChildren.filter(activeSelector).removeClass(activeClass);
					$menuChildren = $menuChildren.has('a[href^="'+relativeUrl+'"],a[href^="/'+relativeUrl+'"],a[href^="'+url+'"]');
					if ( $menuChildren.length === 1 ) { $menuChildren.addClass(activeClass); }

					FadeIn();
				},
				error: function(jqXHR, textStatus, errorThrown){
					document.location.href = url;
					return false;
				}
			}); // end ajax
			
			//-------------------
			//Callback..
			function FadeIn(){
				FADEIN_REQUESTS++;
				if (FADEIN_REQUESTS < 2 && !MUR.isSmall() ) return;
				
				$content.html(PERSISTANT.contentHtml).ajaxify();
				$('body').attr('class',PERSISTANT.bodyClasses).attr('style','');
				$('html').attr('style','');
				
				if ( !MUR.isSmall() ){
				
					new TimelineMax(
					{
						onComplete:function(){
								FADEIN_REQUESTS = 0;
						}
					})
					.set('video',{display:'none'})
					.to($content,1,{opacity:1,scale:1,clearProps:"all"})
					.set('video',{display:'block'})
					.set($content,{overflow:'visible'});
				
				}
			
				// Update the title
				document.title = PERSISTANT.$data.find('.document-title:first').text();
				try {
					document.getElementsByTagName('title')[0].innerHTML = document.title.replace('<','&lt;').replace('>','&gt;').replace(' & ',' &amp; ');
				}
				catch ( Exception ) { }
				
				// Add the scripts
				PERSISTANT.$scripts.each(function(){
					var $script = $(this), scriptText = $script.text(), scriptNode = document.createElement('script');
					if ( $script.attr('src') ) {
						if ( !$script[0].async ) { scriptNode.async = false; }
						scriptNode.src = $script.attr('src');
					}
  				scriptNode.appendChild(document.createTextNode(scriptText));
					contentNode.appendChild(scriptNode);
				});

				// Complete the change
				if ( $body.ScrollTo||false ) { $body.ScrollTo(scrollOptions); } /* http://balupton.com/projects/jquery-scrollto */
				$body.removeClass('loading');
				$body.addClass('loading-completed');
				
				setTimeout(function(){
					$body.removeClass('loading-completed');
				},10)
				
				$window.trigger(completedEventName);

				// Inform Google Analytics of the change
				if ( typeof window._gaq !== 'undefined' ) {
					window._gaq.push(['_trackPageview', relativeUrl]);
				}
				
				if (relativeUrl.substr(0,1) != '/') 
					relativeUrl = '/'+relativeUrl;
					
				if (relativeUrl.substr(-1,1) == '/')
					relativeUrl = relativeUrl.substr(0,relativeUrl.length-1);
				
				// Inform Google Analytics of the change
				if (typeof ga !== 'undefined') {
					ga("send", "pageview", relativeUrl);
				}
				
				// Inform ReInvigorate of a state change
				if ( typeof window.reinvigorate !== 'undefined' && typeof window.reinvigorate.ajax_track !== 'undefined' ) {
					reinvigorate.ajax_track(url);
					// ^ we use the full url here as that is what reinvigorate supports
				}
				
				$('body').trigger('AJAX__reload');
			}

		}); // end onStateChange

	}); // end onDomLoad

})(window); // end closure